import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementsCompareChangeItem extends Layout {
	sourceEdiCompareItem: DataSource;
	tableHandlingChangeItems: Table;
}
